import { HTMLAttributes } from 'react';
import styles from './styles.module.scss';
import { joinClassNames } from '../../utils';

export type SliderHeaderProps = HTMLAttributes<HTMLElement> & {
  variant?: 'primary' | 'secondary' | 'roadblock';
};

export const SliderHeader = ({ children, variant = 'primary', className, ...props }: SliderHeaderProps) => (
  <header className={joinClassNames(styles.sliderHeader, styles[variant], className)} {...props}>
    {children}
  </header>
);
